import React from 'react';
import { ReactComponent as Back } from '../../../assets/svg/chevron-left.svg';
import { ReactComponent as Down } from '../../../assets/svg/down-arrow-search.svg';
import { ReactComponent as Back2 } from '../../../assets/svg/back-icon.svg';

import { ReactComponent as AssignedIcn } from '../../../assets/svg/mc-assign.svg';
import { ReactComponent as ReassignedIcn } from '../../../assets/svg/mc-reassigned.svg';
import { ReactComponent as ReceivedIcn } from '../../../assets/svg/mc-received.svg';
import { ReactComponent as RegisteredIcn } from '../../../assets/svg/mc-registered.svg';
import { withRouter } from '../../../services/withRoute';
import LoadingBar from '../../components/global/loadingBar';
import { gql } from '@apollo/client';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import _ from 'lodash';
import InfiniteScroll from 'react-infinite-scroll-component';
import moment from 'moment';
const getEquipmentsLogs = gql`
	query EqTransactionLogs($filters: EqTransactionListFiltersInput, $eqIdentifier: [String!]!) {
		eqTransactionLogs(filters: $filters) {
			data {
				id
				status
				oldQrCode
				qrCode
				eqId
				description
				createdBy {
					id
					name
				}
				createdAt
				userId
				userName
				eventId
				eventName
				projectName
				isReceived
				manufacturerId
				workspaceId
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			hasPrevPage
			prevPage
			nextPage
		}
		equipmentInfo(eqIdentifier: $eqIdentifier) {
			createdAt
			createdBy
		}
		vendorUsers {
			displayName
			firstName
			lastName
			id
		}
	}
`;

const getOnlyEquipmentsLogs = gql`
	query EqTransactionLogs($filters: EqTransactionListFiltersInput) {
		eqTransactionLogs(filters: $filters) {
			data {
				id
				status
				oldQrCode
				qrCode
				eqId
				description
				createdBy {
					id
					name
				}
				createdAt
				userId
				userName
				eventId
				eventName
				projectName
				isReceived
				manufacturerId
				workspaceId
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			hasPrevPage
			prevPage
			nextPage
		}
	}
`;
class EquipmentLogs extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			limit: 50,
			currentViewPage: 1,
			equipmentsLogsList: [],
			lengthOfList: 0,
			isPageLoading: false,
			isLoading: true,
			hasNextPage: true,
			columns: [
				{ title: 'Date & Time' },
				{ title: '' },
				{ title: 'Type' },
				{ title: 'Project' },
				{ title: 'Description' },
			],
			eqInfo: {},
			tenantUsers: [],
		};
	}
	componentDidMount = () => {
		let filters = {
			filters: {
				limit: this.state.limit,
				page: this.state.currentViewPage,
				qrCode: this.props.params.qrcode,
			},
			eqIdentifier: this.props.params.qrcode,
		};
		this.getEquipmentsLogs(getEquipmentsLogs, filters);
	};
	onClickNextPage = async () => {
		if (this.state.currentViewPage < this.state.totalPages) {
			this.setState(
				{
					currentViewPage: this.state.currentViewPage + 1,
				},
				async () => {
					await this.fetchMoreEQLogs();
				},
			);
		}
	};
	fetchMoreEQLogs = async () => {
		let json = {
			filters: {
				limit: this.state.limit,
				page: this.state.currentViewPage,
				qrCode: this.props.params.qrcode,
			},
		};
		this.getEquipmentsLogs(getOnlyEquipmentsLogs, json);
	};
	goBack = (e) => {
		this.props.navigate(-1);
	};

	eqLogsTable = () => {
		let lastEqLog = {};
		return _.map(this.state.equipmentsLogsList, (eqlog, idx) => {
			let actualLastEqLog = lastEqLog;
			lastEqLog = eqlog;
			return (
				<tr>
					<td>{moment.unix(eqlog.createdAt).format('DD MMM YYYY hh:mm a')}</td>
					<td>
						{(idx === 0 && eqlog.status === 'busy') ||
						(actualLastEqLog.status === 'ready' && eqlog.status === 'busy') ? (
							<AssignedIcn />
						) : idx === 0 && _.has(eqlog, 'oldQrCode') && eqlog.oldQrCode ? (
							<ReassignedIcn />
						) : actualLastEqLog.status === 'busy' &&
						  eqlog.status === 'busy' &&
						  (actualLastEqLog.userId !== eqlog.userId ||
								actualLastEqLog.eventId !== eqlog.eventId) ? (
							<ReassignedIcn />
						) : actualLastEqLog.status === 'busy' && eqlog.status === 'ready' ? (
							<ReceivedIcn />
						) : actualLastEqLog.status === 'ready' && eqlog.status === 'ready' ? (
							<ReceivedIcn />
						) : (
							<ReceivedIcn />
						)}
					</td>
					<td>
						{(idx === 0 && eqlog.status === 'busy') ||
						(actualLastEqLog.status === 'ready' && eqlog.status === 'busy')
							? 'EQ assigned '
							: idx === 0 && _.has(eqlog, 'oldQrCode') && eqlog.oldQrCode
							? 'EQ Remapped'
							: actualLastEqLog.status === 'busy' &&
							  eqlog.status === 'busy' &&
							  (actualLastEqLog.userId !== eqlog.userId ||
									actualLastEqLog.eventId !== eqlog.eventId)
							? 'EQ reassigned'
							: actualLastEqLog.status === 'busy' && eqlog.status === 'ready'
							? 'EQ recieved'
							: actualLastEqLog.status === 'ready' && eqlog.status === 'ready'
							? 'EQ recieved'
							: 'EQ recieved'}
					</td>
					<td
						title={`${eqlog.workspaceId ? `(${eqlog.workspaceId}) ` : ''} ${
							eqlog.projectName ? eqlog.projectName : ''
						}`}
					>
						{eqlog.workspaceId ? `(${eqlog.workspaceId}) ` : ''}
						{eqlog.projectName}
					</td>
					<td>
						{(idx === 0 && eqlog.status === 'busy') ||
						(actualLastEqLog.status === 'ready' && eqlog.status === 'busy')
							? `Assigned to ${eqlog.userName} by ${
									eqlog.createdBy && _.has(eqlog.createdBy, 'name')
										? eqlog.createdBy.name
										: ''
							  }`
							: idx === 0 && _.has(eqlog, 'oldQrCode') && eqlog.oldQrCode
							? `Remapped from ${eqlog.oldQrCode} to ${eqlog.qrCode}`
							: actualLastEqLog.status === 'busy' &&
							  eqlog.status === 'busy' &&
							  (actualLastEqLog.userId !== eqlog.userId ||
									actualLastEqLog.eventId !== eqlog.eventId)
							? `Reassigned to ${eqlog.userName} by ${
									eqlog.createdBy && _.has(eqlog.createdBy, 'name')
										? eqlog.createdBy.name
										: ''
							  }`
							: (actualLastEqLog.status === 'busy' && eqlog.status === 'ready') ||
							  (actualLastEqLog.status === 'ready' && eqlog.status === 'ready')
							? `Recieved from ${eqlog.userName} by ${
									eqlog.createdBy && _.has(eqlog.createdBy, 'name')
										? eqlog.createdBy.name
										: ''
							  }`
							: `Recieved from ${eqlog.userName} by ${
									eqlog.createdBy && _.has(eqlog.createdBy, 'name')
										? eqlog.createdBy.name
										: ''
							  }`}
					</td>
				</tr>
			);
		});
	};
	render() {
		return (
			<>
				<div className="assign-receive-container mc-logs-assign-receive-container">
					<div className="arc-header">
						<div className="back-btn" onClick={(e) => this.goBack(e)}>
							<Back2 />
						</div>
						<div className="arc-header-container">
							<div className="arch-item">
								<span className="">
									<p>Equipment</p>
									<b>{this.props.params.qrcode}</b>
								</span>
							</div>
							<div className="next-btn">
								<Back />
							</div>
							<div className="arch-item">
								<span className="arc-title">Equipment Logs</span>
							</div>
						</div>
					</div>
					<div className={'table shoots-table'} id={'scrollableDiv-shoots-vendors'}>
						{this.state.isLoading === true ? (
							<LoadingBar />
						) : (
							<div className="projects-table-outer-container">
								{_.size(this.state.equipmentsLogsList) === 0 &&
								_.size(this.state.eqInfo) === 0 ? (
									<div
										style={{
											display: 'flex',
											width: '100%',
											height: '100%',
											alignItems: 'center',
											justifyContent: 'center',
											color: '#E4E5E6',
											fontFamily: 'Inter Medium',
											fontSize: '14px',
											fontWeight: 500,
											lineHeight: '16px',
											letterSpacing: '-0.3px',
										}}
									>
										No Equipment logs found
									</div>
								) : (
									<InfiniteScroll
										dataLength={this.state.lengthOfList}
										next={() => {
											this.onClickNextPage();
										}}
										hasMore={this.state.hasNextPage}
										loader={
											<div
												style={{
													color: '#fff',
													textAlign: 'center',
													width: '100%',
													padding: '20px',
												}}
											>
												Loading...
											</div>
										}
										scrollableTarget={'scrollableDiv-shoots-vendors'}
										scrollThreshold={0.5}
									>
										<table className="shootTable">
											<thead>
												<tr>
													{_.map(this.state.columns, (column, key) => {
														return <th>{column.title}</th>;
													})}
												</tr>
											</thead>
											<tbody className="eq-logs-tbody">
												{this.eqLogsTable()}
												{this.state.hasNextPage === false &&
												this.state.eqInfo &&
												_.size(this.state.eqInfo) > 0 &&
												_.has(this.state.eqInfo[0], 'createdAt') ? (
													<tr>
														<td>
															{moment
																.unix(
																	this.state.eqInfo[0].createdAt,
																)
																.format('DD MMM YYYY hh:mm a')}
														</td>
														<td>
															<RegisteredIcn />
														</td>
														<td>EQ Registered</td>
														<td>-</td>
														<td>
															By{' '}
															{_.capitalize(
																_.find(this.state.tenantUsers, {
																	id: this.state.eqInfo[0]
																		.createdBy,
																})?.name,
															)}
														</td>
													</tr>
												) : null}
											</tbody>
										</table>
									</InfiniteScroll>
								)}
							</div>
						)}
					</div>
				</div>
			</>
		);
	}
}
export default withRouter(EquipmentLogs);
